export default __webpack_public_path__ + "static/bg1-h-d729c362b2d6c3b370fbbbddb4293b76.jpg";